// TODO: Replace with the appropriate links for HPHC.
export const EXTERNAL_LINKS = {
  DISCLAIMER: 'https://google.com/disclaimer',
  APPLE_STORE_APP: 'https://apple.com',
  GOOGLE_PLAY_STORE_APP: 'https://google.com',
};

// Placeholder internal routes for footer links until real pages exist.
export const INTERNAL_LINKS = {
  ABOUT: '/about',
  CONTACT_US: '/contact',
  TERMS: '/terms',
  POLICY: '/policy',
};
